import { cn } from "@/lib/cn";

/** Reemplazo de `<Kbd>` de Mantine · tecla de teclado (ej. hint "Ctrl" "K" del command palette). */
export function Kbd({ className, ...props }: React.HTMLAttributes<HTMLElement>) {
  return (
    <kbd
      className={cn(
        "inline-flex items-center justify-center rounded-sm border border-border bg-muted px-1.5 py-0.5 font-mono text-xs text-muted-foreground",
        className
      )}
      {...props}
    />
  );
}
